import React, { useState } from "react";
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import {
  getMessaging,
  getToken,
  isSupported,
  onMessage,
} from "firebase/messaging";
import toastr from "toastr";
import { Alert } from "reactstrap";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
// const firebaseConfig = {
//     apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
//     authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
//     projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
//     storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
//     messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
//     appId: process.env.REACT_APP_FIREBASE_APP_ID,
//     measurementId: process.env.REACT_APP_FIREBASE_MEASURMENT_ID
// };

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// const messaging = getMessaging(app);
const messaging = (async () => {
  try {
    const isSupportedBrowser = await isSupported();
    if (isSupportedBrowser) {
      return getMessaging(app);
    }
    console.log("Firebase not supported this browser");
    return null;
  } catch (err) {
    console.log(err);
    return null;
  }
})();

export const Sendrequest = () => {
  console.log("Requesting User Permission……");
  if (Notification.permission !== "granted") {
    Notification.requestPermission().then((permission) => {
      if (permission === 'granted') {
      console.log("Notification User Permission Granted.");
      return getToken(messaging, {
        vapidKey: `BPeaqpU7Fv0N1ZHiO73ifEidN_CsaUdOYTmzmF2ux_EX3EhSBtzmxTSQTpgSo1UxlTDvcoUILDIdDBJ5N89FUEE`,
      })
        .then((currentToken) => {
          if (currentToken) {
            console.log("Client Token: ", currentToken);
          } else {
            console.log("Failed to generate the registration token.");
          }
        })
        .catch((err) => {
          console.log(
            "An error occurred when requesting to receive the token.",
            err
          );
        });
      } else {
          console.log('User Permission Denied.');
      }
    });
  }
};

// export const getTokenFCM = () => {
//     console.log('dfdsfd')
//     return getToken(messaging, { vapidKey: `BHq1NdvVCF8wUVeUyEJ2Nkn65jp2IgkZXuSDyjGWWB2tSA7Hg6rusg9cSObsyHR9cGoK9i9mI8IaAZi1ATeRl7c` })
//         .then(currentToken => {
//             if (currentToken) {
//                 console.log(currentToken)
//             } else {
//                 console.log('No registration')
//             }
//         }).catch(err => console.log('An error occur', err))
// }
// export const onMessageListner = () => {

// let notification;
// new Promise(resolve => {

onMessage(messaging, (payload) => {
  console.log("Message received. ", payload);
  toastr.info(
    `Title: ${payload.notification.title}, Desc: ${payload.notification.body}`
  );
  // resolve({
  //     title: payload.notification.title,
  //     desc: payload.notification.body
  // })
});
// });

// return notification;
// }
